import * as React from 'react';
import { useState } from 'react';
import { Box, Button, Loader, IconButton } from 'wix-style-react';
import { saveAs } from 'file-saver';
import DownloadImport from 'wix-ui-icons-common/DownloadImport';
import { HttpClient } from '@wix/http-client';

const httpClient = new HttpClient();

export const xsrfCookieKey = 'XSRF-TOKEN';
export const xsrfHeaderKey = 'x-xsrf-token';

export const getXsrfCookie = () => {
  const x = document.cookie.indexOf(xsrfCookieKey);
  const y = document.cookie.indexOf('=', x);
  const z = document.cookie.includes(';', y)
    ? document.cookie.indexOf(';', y)
    : undefined;
  return document.cookie.substring(y + 1, z);
};

const downloadPdf = (pdfUrl, onDownloadPDF, token) => {
  return httpClient.post(pdfUrl, {token, 'x-xsrf-token': getXsrfCookie()}, {
    headers: {
      'content-type': 'application/json',
      'Accept': 'text/html,application/xhtml+xml',
    },
    responseType: 'blob',
  })
}

const MobilePdfButton = (props) => (
  <IconButton priority='secondary' {...props}>
    <DownloadImport/>
  </IconButton>
);

export const PdfDownloader = ({ token, text, pdfUrl, onDownloadPDF, onDownloadFail, newMobileViewEnabled = false }) => {
  const [showLoader, setShowLoader] = useState(false);

  const PdfButton = (props) =>  newMobileViewEnabled ?
    <MobilePdfButton {...props}/> :
    <Button theme="whiteblueprimary" {...props}/>

  return (
    <PdfButton dataHook="download-pdf-button" onClick={() => {
      setShowLoader(true);
      downloadPdf(pdfUrl, onDownloadPDF, token)
        .then((response => {
          saveAs(response.data, 'Invoice.pdf');
          onDownloadPDF();
        }))
        .catch(onDownloadFail)
        .then(() => setShowLoader(false));
    }}>
      <Box align="center" {...newMobileViewEnabled ? {} : { width: "110px" }}>
        {showLoader ? <Loader size="tiny" /> : text}
      </Box>
    </PdfButton>
  )
}
